/* onbond.js — brand JS bootstrap */
(function () {
  'use strict';

  /* ── Variant radio picker ──────────────────────────────────────────────── */
  class VariantRadios extends HTMLElement {
    connectedCallback() {
      this._form    = this.closest('form') || document.getElementById('product-form');
      this._idInput = this.querySelector('[data-variant-id-input]') ||
                      (this._form && this._form.querySelector('[data-variant-id-input]'));
      this._productUrl = this.dataset.url || '';
      this._productData = null;

      if (this._productUrl) {
        fetch(this._productUrl + '.js')
          .then(r => r.json())
          .then(p => { this._productData = p; })
          .catch(() => {});
      }

      this.querySelectorAll('input[type="radio"]').forEach(inp => {
        inp.addEventListener('change', () => this._onOptionChange());
      });
    }

    _onOptionChange() {
      if (!this._productData) return;
      const selected = {};
      this.querySelectorAll('input[type="radio"]:checked').forEach(inp => {
        const name = inp.name.replace(/^options\[(.+)\]$/, '$1');
        selected[name] = inp.value;
      });
      const variant = this._productData.variants.find(v =>
        v.options.every((opt, i) => opt === selected[this._productData.options[i]])
      );
      if (!variant) return;
      if (this._idInput) this._idInput.value = variant.id;
      const priceEl = document.querySelector('.onbond-pdp__price');
      if (priceEl) {
        const cents = variant.price;
        const fmt = '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
        priceEl.textContent = fmt;
      }
      const buyNow = document.querySelector('[data-buy-now]');
      const addBtn = document.querySelector('[data-add-to-cart]');
      const disabled = !variant.available;
      if (buyNow) buyNow.disabled = disabled;
      if (addBtn) addBtn.disabled = disabled;
    }
  }

  if (!customElements.get('variant-radios')) {
    customElements.define('variant-radios', VariantRadios);
  }

  /* ── Add to Vault from product card ───────────────────────────────────── */
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-add-first-variant]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    const id = btn.dataset.variantId;
    if (!id) return;
    const original = btn.textContent;
    btn.textContent = '...';
    btn.disabled = true;
    try {
      await window.OnbondCart.add({ id, quantity: 1 });
      const drawer = document.querySelector('onbond-cart-drawer');
      if (drawer) drawer.open();
    } catch (err) {
      console.warn('Add to vault failed:', err.message);
    } finally {
      btn.textContent = original;
      btn.disabled = false;
    }
  });

  /* ── Add to Cart form submit ───────────────────────────────────────────── */
  document.addEventListener('submit', (e) => {
    const f = e.target.closest('#product-form');
    if (!f) return;
    e.preventDefault();
    const fd = new FormData(f);
    window.OnbondCart.addFromForm(fd).then(() => {
      const drawer = document.querySelector('onbond-cart-drawer');
      if (drawer) drawer.open();
    }).catch(err => console.warn(err.message));
  });

  /* ── Buy Now ───────────────────────────────────────────────────────────── */
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-buy-now]');
    if (!btn) return;
    const popup = window.open('about:blank', '_blank');
    const f = btn.closest('form');
    if (!f) return;
    const fd = new FormData(f);
    try {
      await window.OnbondCart.addFromForm(fd);
      const url = '/checkout';
      if (popup) popup.location.href = url;
      else window.location.href = url;
    } catch (err) {
      if (popup) popup.close();
      console.warn(err.message);
    }
  });

  /* ── Open cart drawer ──────────────────────────────────────────────────── */
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-action="open-cart"]') || e.target.closest('.onbond-vault-pill')) {
      const drawer = document.querySelector('onbond-cart-drawer');
      if (drawer) drawer.open();
    }
  });

  /* ── Search drawer ─────────────────────────────────────────────────────── */
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-action="open-search"]')) {
      const sd = document.querySelector('[data-search-drawer]');
      if (!sd) return;
      const hidden = sd.hasAttribute('hidden');
      if (hidden) {
        document.querySelector('.onbond-mobile-nav')?.classList.remove('is-open');
        sd.removeAttribute('hidden');
        const inp = sd.querySelector('input');
        if (inp) inp.focus();
      } else {
        sd.setAttribute('hidden', '');
      }
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      const sd = document.querySelector('[data-search-drawer]');
      if (sd && !sd.hasAttribute('hidden')) sd.setAttribute('hidden', '');
    }
  });

  /* ── Mobile nav hamburger ──────────────────────────────────────────────── */
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-hamburger]')) {
      const nav = document.querySelector('.onbond-mobile-nav');
      if (nav) {
        const opening = !nav.classList.contains('is-open');
        if (opening) document.querySelector('[data-search-drawer]')?.setAttribute('hidden', '');
        nav.classList.toggle('is-open');
      }
    }
  });

  /* ── Horizontal scroll chevrons ────────────────────────────────────────── */
  document.addEventListener('click', (e) => {
    const prev = e.target.closest('[data-scroll-prev]');
    const next = e.target.closest('[data-scroll-next]');
    if (!prev && !next) return;
    const section = (prev || next).closest('.onbond-row-section');
    if (!section) return;
    const track = section.querySelector('[data-scroll]');
    if (!track) return;
    const dir = prev ? -1 : 1;
    track.scrollBy({ left: dir * track.clientWidth * 0.8, behavior: 'smooth' });
  });

  /* ── Vault grid load more ───────────────────────────────────────────────── */
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-loadmore]');
    if (!btn) return;
    const nextUrl = btn.dataset.nextUrl;
    if (!nextUrl) return;
    btn.textContent = 'Loading...';
    btn.disabled = true;
    try {
      const sectionId = btn.closest('[data-vault-grid]')
        ? btn.closest('.onbond-vault-section')?.querySelector('[data-vault-grid]')
        : null;
      const url = nextUrl + (nextUrl.includes('?') ? '&' : '?') + 'sections=vault-grid';
      const r = await fetch(url);
      const j = await r.json();
      const html = j['vault-grid'] || '';
      const tpl = document.createElement('template');
      tpl.innerHTML = html;
      const grid = btn.closest('[data-vault-grid]');
      if (grid) {
        const newCards = tpl.content.querySelectorAll('.onbond-product-card');
        newCards.forEach(c => grid.insertBefore(c, btn.parentElement));
        const nextBtn = tpl.content.querySelector('[data-loadmore]');
        if (nextBtn) {
          btn.dataset.nextUrl = nextBtn.dataset.nextUrl;
          btn.textContent = 'Load more';
          btn.disabled = false;
        } else {
          btn.parentElement.remove();
        }
      }
    } catch (err) {
      btn.textContent = 'Load more';
      btn.disabled = false;
    }
  });

  /* ── Filter show-all ────────────────────────────────────────────────────── */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-show-all]');
    if (!btn) return;
    const fs = btn.closest('fieldset');
    if (!fs) return;
    fs.querySelectorAll('.onbond-chip').forEach(chip => chip.style.display = '');
    btn.remove();
  });

})();
